/** @module csi/action/GroupController */
define([
    "dojo/_base/declare",
    "csi/action/Controller"
], function(declare,Controller) {

    return declare(Controller, {
    	/** @property {Result} qrGroup - group query result */
    	qrGroup: null,
    	
    	/** @property {string} urlGroupNode - client URL representing group (not group's value) */
        urlGroupNode: null,

        /**
         * Substitute controller URL with group's value (presumed to be URL)
         */
        constructor: function() {
        	this.qrGroup = this.widget.getQueryResultByDomNode(this.refNode || this.m_element);
            this.urlGroupNode = this.m_urlNode;
            this.m_urlNode = this.qrGroup.groupValue;
        }
    });
});
